import styles from './Logo.module.scss'
import LogoIcon from '../../assets/logo.svg'
import { useNavigate } from 'react-router-dom'

const Logo = () => {
  const navigate = useNavigate()

  return (
    <div className={styles.logo} onClick={() => {navigate('/')}}>
      <img src={LogoIcon}/>
      <h2>JobMagazine</h2>
    </div>
  )
}

export default Logo